module.exports = __webpack_public_path__ + "img/re-result-7.04afb692.jpg";